export default __webpack_public_path__ + "static/media/EN_01.0679229e.svg";